import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { VStack } from "@whoosh/design-system/src/components/primitive";
import { normalizeBookingRules } from "@whoosh/features/src/Restrictions";

import { InlineRestriction } from "./InlineRestriction";
import { InlineRestrictionsList_timeSlot$key } from "./__generated__/InlineRestrictionsList_timeSlot.graphql";

type Props = {
  timeSlotRef: InlineRestrictionsList_timeSlot$key;
};

export const InlineRestrictionsList = ({ timeSlotRef }: Props) => {
  const timeSlot = useFragment(
    InlineRestrictionsListFragmentString,
    timeSlotRef
  );

  const restrictions =
    normalizeBookingRules(
      timeSlot?.bookingRules?.edges?.flatMap((edge) =>
        edge?.node ? [edge.node] : []
      )
    ) || [];

  if (restrictions.length === 0) {
    return null;
  }

  return (
    <VStack>
      {restrictions.map((restriction) => {
        return (
          <InlineRestriction
            key={restriction.id}
            name={restriction.name}
            displayName={restriction.displayName}
            visibilityColor={restriction.visibilityColor}
          />
        );
      })}
    </VStack>
  );
};

const InlineRestrictionsListFragmentString = graphql`
  fragment InlineRestrictionsList_timeSlot on TimeSlot {
    bookingRules(
      type: [RESTRICTION]
      bookingType: [STANDARD]
      memberVisibility: SLOTS_AND_RESTRICTION_INLINE
      memberOverride: [NONE, WARN]
    ) {
      edges {
        node {
          id
          name
          displayName
          ... on BookingRestrictionRule {
            visibilityColor
          }
        }
      }
    }
  }
`;
